module.exports = __webpack_public_path__ + "static/media/selected_tire_orange.f4d5fc10.svg";